import React from 'react'
import './stories.css'
import Hero from './components/Hero'
import Stories from './components/Stories'

const SuccessStories = () => {
  return (
    <>
      <Hero />
      <Stories />
    </>
  )
}

export default SuccessStories
